import { ClusteredMarkerLayer } from '../Layers/ClusteredMarkersLayer';
import { FilterLayer } from '../Layers/FilterLayer';
import type { FilterLayerOptions } from '../Layers/Layers.types';

export const iconIdFilter = function (layers: ClusteredMarkerLayer[], iconIds: number[], options?: FilterLayerOptions): FilterLayer {
    const defaultOptions: FilterLayerOptions = {
        filterFn: (filteredFeatures, allFeatures) => {
            return allFeatures.filter((feature) => {
                const props = feature.properties;
                return props.iconId && iconIds.includes(props.iconId);
            });
        },
    };

    return new FilterLayer('icon-id-filter', layers, { ...defaultOptions, ...options });
};
